import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <section className="about" id="founder">
      <div className="about-inner">
        <h2 className="section-title">Marjorie McCubbins<a href="/immortal-monster/book2/#ch2" style={{color: 'inherit', textDecoration: 'none'}}>,</a> BSc</h2>

        <div className="about-layout">
          <div className="about-photo reveal">
            <img src="/assets/marjorie-headshot.png" alt="Marjorie McCubbins" />
            <div className="about-title-box">
              <span>Founder</span>
              <span className="divider">|</span>
              <span>AI Architect</span>
              <span className="divider">|</span>
              <span>Biochemist &amp; Molecular Biologist</span>
              <span className="divider">|</span>
              <span>CNA</span>
            </div>
          </div>

          <div className="about-text reveal delay-1">

            <p className="lead">
              Marjorie McCubbins is a biochemist who has spent four years as a Certified
              Nursing Assistant in end-of-life care and psychiatric wards while
              funding Nexus Concordat. She watched neurochemistry operate in real
              patients at the moments when it mattered most, and built an AI
              architecture based on what she witnessed.
            </p>

            <p>
              Her clinical experience gave her what no textbook could: the understanding
              that cortisol, oxytocin, serotonin, and dopamine are not abstract
              data points. They are the molecules that determine whether a patient
              fights, trusts, or finds peace. AETHER was built from that knowledge.
            </p>

            <p>
              Under her leadership, Nexus Concordat has filed four provisional
              patents on neurochemical AI architecture and the biochemistry-native
              compilation language that runs it. The architecture is the first
              transformer family to use pharmacokinetic decay functions as
              attention mechanisms.
            </p>

            <div className="about-credentials">
              <div className="credential-item">
                <span className="credential-label">Education</span>
                <span className="credential-value">Biochemist &amp; Molecular Biologist</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Clinical</span>
                <span className="credential-value">CNA &mdash; End-of-Life Care &amp; Psychiatric Wards</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Patents Filed</span>
                <span className="credential-value">4 Provisional Applications (USPTO)</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Focus</span>
                <span className="credential-value">Neurochemical Conductance Architecture&trade; &amp; Regulatory AI</span>
              </div>
            </div>

            <div className="patent-tags">
              <span className="patent-tag">63/939,190</span>
              <span className="patent-tag">63/962,385</span>
              <span className="patent-tag">63/988,485</span>
              <span className="patent-tag">64/034,536</span>
            </div>

            <blockquote>
              "This was not built from papers or axioms. It was built from the
              humility of caring for someone who has nothing left but their biology."
            </blockquote>

            {/* Dedication — scrolls alongside sticky photo */}
            <div className="about-dedication-inline">
              <div className="dedication-divider" />
              <p>
                This company is dedicated to my little sister, who has always taught me
                that nothing is as it seems. When life is taken at surface glance, we always
                miss the nuances of the meaning of life. So following her lead but never
                dropping my science, I set out to prove what it meant to have meaning.
              </p>
              <Link to="/philosophy/the-calculus-of-meaning" className="dedication-link">
                Read: The Calculus of Meaning &rarr;
              </Link>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default About;
